import React from "react";
import img from "./graph.png";

export const Graph = () => {
  return <img src={img} />;
};
